import { render, staticRenderFns } from "./ResetPasswordNew.vue?vue&type=template&id=60dbfa1a&scoped=true&"
import script from "./ResetPasswordNew.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordNew.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordNew.vue?vue&type=style&index=0&id=60dbfa1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dbfa1a",
  null
  
)

export default component.exports